import React from 'react';
import { Box, Typography, IconButton, Grid, Link, useMediaQuery } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import { useTheme } from '@mui/material/styles';

const ContactSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box sx={{ backgroundColor: 'white', textAlign: 'center', padding: 4, color: 'black' }}>
       <Typography variant={isMobile ? 'body1' : 'h5'} sx={{ marginBottom: 2, fontSize: isMobile ? '16px' : '20px' }}>
            Feel free to explore my portfolio and reach out if you'd like to
            discuss potential collaborations or opportunities in software development!
          </Typography>

      <IconButton sx={{ color: 'black', '&:hover': { color: '#f9004d' } }} href="mailto:pandeyanand2099@gmail.com">
        <EmailIcon sx={{ fontSize: 40 }} />
      </IconButton>
      <IconButton sx={{ color: 'black', '&:hover': { color: '#f9004d' } }} href="https://github.com/Anand200399">
        <GitHubIcon  sx={{ fontSize: 40 }} />
      </IconButton>
      <IconButton sx={{ color: 'black', '&:hover': { color: '#f9004d' } }} href="https://www.linkedin.com/in/anand-pandey-9a947520b">
        <LinkedInIcon sx={{ fontSize: 40 }} />
      </IconButton>

      {/* Footer */}
      <Box component="footer" sx={{ mt: 4, borderTop: 1, borderColor: 'grey.700', pt: 2 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1" color={'#f9004d'}gutterBottom>
              © 2024 Aannd Pandey Portfolio
            </Typography>
            {/* <Link href="#" sx={{ color: 'grey.500', '&:hover': { color: '#f9004d' } }}>
              Privacy Policy
            </Link> */}
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1" gutterBottom>
              Follow Us
            </Typography>
            <IconButton sx={{ color: 'white', '&:hover': { color: '#f9004d' } }} href="https://github.com">
              <GitHubIcon />
            </IconButton>
            <IconButton sx={{ color: 'white', '&:hover': { color: '#f9004d' } }} href="https://linkedin.com">
              <LinkedInIcon />
            </IconButton>
          </Grid> */}
          <Grid item xs={12} sm={4}>
            <Typography>
            <Link href="mailto:pandeyanand2099@gmail.com" sx={{ color: 'grey.500', '&:hover': { color: '#f9004d' } }}>
              pandeyanand2099@gmail.com
            </Link>
            </Typography>
            <Typography>
            <Link href="tel:+14086409974" sx={{ color: 'grey.500', '&:hover': { color: '#f9004d' } }}>
              +1 408 640 9974
            </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ContactSection;
